import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import EditIcon from '../../../assets/img/svg/edit-icon.svg'
import RoomIcon from '../../../assets/img/svg/room-icon.svg'
import BathroomIcon from '../../../assets/img/svg/bathroom-icon.svg'
import HouseImg from '../../../assets/img/house-img.png'
import HouseImg1 from '../../../assets/img/house-img1.jpg'
import HouseImg2 from '../../../assets/img/house-img2.jpg'
import HouseImg3 from '../../../assets/img/house-img3.jpg'
import HouseImg4 from '../../../assets/img/house-img4.jpg'
import HouseImg5 from '../../../assets/img/house-img5.jpg'
import { Accordion, Spinner } from 'react-bootstrap'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { ModalTitle } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import CelanderIcon from '../../../assets/img/svg/calendar-icon.svg'
import ClockIcon from '../../../assets/img/svg/clock-icon.svg'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { registerLocale } from 'react-datepicker'
import { es } from 'date-fns/locale/es'
registerLocale('es', es)
import CleaningScheduleDetail from '../../../component/Property/Schedule/cleaningScheduleModel'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { createManualPropertySchedule, getPropertyScheduleById } from '../../../redux/slices/propertySlice'
import { errorToast, successToast } from '../../../util/Toast/toast'
import {
  appendImageURL,
  capitalizeAndRemoveUnderscore,
  convertTimestampToCalenderDate,
  convertTimestampToDate,
  convertTimestampToTime,
  getDayStartAndEndTimestamps,
  getDefaultTime,
  getISOToUTCDateFromTimestamp,
  // convertUnixToDate,
  getTimeStamp,
  isDateBefore,
  OVERDUE
} from '../../../helper/function'
import dayjs from 'dayjs'
import { scheduleCleningSchema } from '../../../util/validationSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { PropertyCardSliderDefaultImg } from '../../../helper/imagepath'
import { applyCoupons, resetCouponsState } from '../../../redux/slices/couponsSlice'
import CommonDateTimePicker from '../../../component/commonDateTimePicker'
import { FREEZE_CLIENT_MSG } from '../../../util/constant'

// eslint-disable-next-line no-unused-vars
const EditProperty = ({
  getProperty,
  property_image = [],
  errors,
  control,
  trigger,
  watch,
  setIsRefresh,
  setIsAboutToggle,
  isAboutToggle,
  onAccordionChange,
  accrdionActiveKey
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { user } = useSelector(({ auth }) => auth)
  const { allScheduledProperties } = useSelector(({ property }) => property)
  const { couponsInfo } = useSelector((state) => state.coupons)

  const {
    control: scheduleControl,
    handleSubmit: handleScheduleCleaningSubmit,
    setValue: setScheduleValue,
    reset: scheduleReset
  } = useForm({
    resolver: yupResolver(scheduleCleningSchema),
    defaultValues: {
      booking_date_time: getISOToUTCDateFromTimestamp(getDefaultTime(11)), // 11:00 AM
      next_checkin_time: getISOToUTCDateFromTimestamp(getDefaultTime(16)), // 4:00 PM
      coupon: ''
    }
  })
  const [isCanceledBookingStatus, setIsCanceledBookingStatus] = useState(false)
  const [showMoreDetailModal, setShowMoreDetailModal] = useState(false)
  const toggleMoreDetailModal = () => setShowMoreDetailModal(!showMoreDetailModal)
  const [selectedDate, setSelectedDate] = useState(null)
  const [isLoader, setIsLoader] = useState(false)
  const [scheduleID, setScheduleID] = useState(null)
  const [displayImages, setDisplayImages] = useState([])

  useEffect(() => {
    if (errors?.number_of_bathroom || errors?.number_of_rooms || errors?.square_foot) {
      setIsAboutToggle(true)
    }
  }, [errors])

  const amountValue = useMemo(() => {
    if (getProperty) {
      const total_value = getProperty?.total_value || 0
      const discount = 0
      const final_value = getProperty?.total_value
      return { total_value, discount, final_value }
    }
  }, [allScheduledProperties?.scheduledProperties])

  const calendarLegend = [
    { title: 'Current Date', color: 'current-dot' },
    { title: 'Scheduled', color: 'scheduled-dot' },
    { title: 'Cleaning Completed', color: 'cleaning-scheduled-dot' },
    { title: 'In Progress', color: 'cleaning-inprogress-dot' },
    { title: 'Cancel', color: 'cleaning-canceled-dot' },
    { title: 'Canceled Cleaner', color: 'cleaning-canceled-cleaner-dot' }
  ]

  const initialCost = couponsInfo?.amount || amountValue?.total_value || 0
  const discount = couponsInfo?.discount || amountValue?.discount || 0
  const finalCost = couponsInfo?.final_amount || amountValue?.final_value || 0
  // -----Images-----------

  useEffect(() => {
    const propertyImages = property_image?.length ? property_image?.slice(0, 5) : getProperty?.property_image?.slice(0, 5) || [] // Get only the first 5 images

    // Array of random images for fallback
    const randomImages = [HouseImg, HouseImg1, HouseImg2, HouseImg3, HouseImg4, HouseImg5] // Replace these with your actual random images

    // Function to get random images without repetition
    const getRandomImages = (count) => {
      const selectedImages = new Set()
      const availableImages = randomImages.filter((img) => !propertyImages.includes(img))

      while (selectedImages.size < count && availableImages.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableImages.length)
        selectedImages.add(availableImages[randomIndex])
        availableImages.splice(randomIndex, 1) // Remove the selected image to avoid repetition
      }

      return Array.from(selectedImages)
    }

    const requiredRandomImagesCount = 5 - propertyImages.length
    const randomImagesToDisplay = requiredRandomImagesCount > 0 ? getRandomImages(requiredRandomImagesCount) : []

    setDisplayImages([...propertyImages, ...randomImagesToDisplay]?.slice(0, 5))
  }, [property_image])

  // Example function to retrieve a local date from booking
  const getBookingDate = (bookingTimestamp) => {
    return convertTimestampToCalenderDate(bookingTimestamp) // Returns UTC Date object
  }

  const dayClassName = (date) => {
    const today = dayjs().startOf('day')
    if (dayjs(date).isSame(today, 'day')) {
      return 'today'
    }
    const bookings = getProperty?.propertySchedule?.filter((b) => {
      const bookingDate = getBookingDate(b.booking_date_time)
      return dayjs(bookingDate).isSame(dayjs(date), 'day')
    })
    return bookings?.length > 0 ? 'has-booking' : ''
  }

  const renderDayContents = (day, date) => {
    const bookings = getProperty?.propertySchedule?.filter((b) => {
      const bookingDate = getBookingDate(b.booking_date_time)
      return dayjs(bookingDate).isSame(dayjs(date), 'day')
    })
    if (!bookings || bookings.length === 0) return day
    const maxDots = 5
    const limitedBookings = bookings.slice(0, maxDots)
    return (
      <div className="custom-day">
        {day}
        <div className="dot-container">
          {limitedBookings.map((booking, index) => {
            let dotClass = ''
            switch (booking.booking_status) {
              case 'completed':
                dotClass = 'dot-completed'
                break
              case 'scheduled':
                dotClass = 'dot-scheduled'
                break
              case 'in progress':
                dotClass = 'dot-inprogress'
                break
              case 'canceled cleaner':
                dotClass = 'dot-cleaner-cancel'
                break
              case 'canceled':
                dotClass = 'dot-cancel'
                break
              default:
                dotClass = ''
            }
            return <span key={index} className={`dot ${dotClass}`}></span>
          })}
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (getProperty?.properties_id) {
      // Select the current date when the component mounts
      handleDateSelect(dayjs().toDate().toString())
    }
  }, [getProperty])

  // Handle date change in the date picker
  const handleDateChange = useCallback((date) => {
    setSelectedDate(date) // Stores the selected date in state
  }, [])

  // Handle date select event (called when a date is selected in the calendar)
  const handleDateSelect = async (date) => {
    const formattedDate = getTimeStamp(dayjs(date).format('YYYY-MM-DDTHH:mm'))
    const { startOfDayTimestamp, endOfDayTimestamp } = getDayStartAndEndTimestamps(formattedDate)
    try {
      const payload = {
        property_id: getProperty?.properties_id,
        params: { start_date: startOfDayTimestamp, end_date: endOfDayTimestamp } // Assumes `getTimeStamp` is defined elsewhere
      }

      setIsLoader(true)

      // Dispatch the action to fetch property schedule based on the selected date
      await dispatch(getPropertyScheduleById(payload))
      setIsLoader(false)
    } catch (err) {
      console.error('Error fetching property schedule:', err)
      setIsLoader(false)
    }
  }
  // ----------------------------------------------------------------------

  useEffect(() => {
    setScheduleValue('properties_id', getProperty?.properties_id)
    setScheduleValue('is_automated', false)
    setScheduleValue('cleaning_on', watch('cleaning_on'))
  }, [getProperty, watch('cleaning_on')])

  const handleMoreDetailsClick = (schedule) => {
    setScheduleID(schedule?.property_schedule_id)
    setIsCanceledBookingStatus(false)
    if (schedule.booking_status === 'scheduled') {
      toggleMoreDetailModal()
    } else if (schedule.booking_status === 'completed' || schedule.booking_status === 'canceled cleaner') {
      navigate(`/cleaning-details/${schedule.property_schedule_id}`)
    } else if (['canceled', 'in progress']?.includes(schedule?.booking_status)) {
      setIsCanceledBookingStatus(true)
      toggleMoreDetailModal()
    } else {
      return
    }
  }

  const handleApplyCoupon = (coupon) => {
    if (!coupon) {
      return
    }
    if (!amountValue?.total_value) {
      errorToast('You can not schedule cleaning as admin not added to your property total value')
      return
    }

    const payload = { code: coupon, amount: amountValue?.total_value }
    changeLoader(true)

    return dispatch(applyCoupons(payload))
      .then(({ payload }) => {
        if (payload?.status === 200 || payload?.data?.status_code === 200) {
          successToast(payload?.data?.status_message || 'Coupon applied successfully!')
          return true
        } else {
          errorToast(payload?.data?.status_message || 'Coupon code is not valid')
          return false
        }
      })
      .catch((err) => {
        console.error('Coupon application error:', err)
        errorToast('Something went wrong while applying the coupon.')
        return false
      })
      .finally(() => {
        changeLoader(false)
      })
  }

  const handleCreateSchedule = (payload) => {
    changeLoader(true)
    dispatch(createManualPropertySchedule(payload))
      .then(({ payload }) => {
        if (payload?.status === 200 || payload?.data?.status_code === 200) {
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Schedule created successfully!')
          scheduleReset()
          dispatch(resetCouponsState())
        } else {
          errorToast(payload?.data?.status_message || 'Failed to create schedule.')
        }
      })
      .catch((err) => {
        console.error('Schedule creation error:', err)
        errorToast('Something went wrong while creating the schedule.')
      })
      .finally(() => {
        changeLoader(false)
      })
  }

  const onSubmit = (data) => {
    if (user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    setIsRefresh(false)

    // Prepare payload
    delete data?.cleaning_on

    const payload = {
      ...data,
      booking_date_time: data.booking_date_time ? getTimeStamp(data.booking_date_time) : undefined,
      next_checkin_time: data.next_checkin_time ? getTimeStamp(data.next_checkin_time) : undefined
    }

    // Clean up empty fields
    if (!payload?.booking_date_time) delete payload?.booking_date_time
    if (!payload?.next_checkin_time) delete payload?.next_checkin_time

    handleCreateSchedule(payload)
  }

  const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)

  return (
    <>
      <div className="house_img_gal_main_div mb-3">
        <div className="row">
          <div className="col-md-6">
            <div className="main_big_img">
              <img className="img-fluid w-100" src={displayImages?.[0] ? appendImageURL(displayImages?.[0]) : HouseImg1} alt="Image" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="house_img_mb main_small_img">
              <img className="img-fluid w-100" src={displayImages?.[1] ? appendImageURL(displayImages?.[1]) : HouseImg2} alt="Image" />
            </div>
            <div className="main_small_img">
              <img className="img-fluid w-100" src={displayImages?.[2] ? appendImageURL(displayImages?.[2]) : HouseImg3} alt="Image" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="house_img_mb main_small_img">
              <img className="img-fluid w-100" src={displayImages?.[3] ? appendImageURL(displayImages?.[3]) : HouseImg4} alt="Image" />
            </div>
            <div className="main_small_img last_img_rad">
              <img className="img-fluid w-100" src={displayImages?.[4] ? appendImageURL(displayImages?.[4]) : HouseImg5} alt="Image" />
            </div>
          </div>
        </div>
      </div>
      {/* Accordion Design Start */}
      <div className="accordion_main_div">
        <Accordion activeKey={accrdionActiveKey}>
          <Accordion.Item eventKey="schedule">
            <Accordion.Header onClick={() => onAccordionChange('schedule')}>Schedule</Accordion.Header>
            <Accordion.Body>
              <div className="schedule_cleaning_main_div">
                <form>
                  <div className="row">
                    <div className="col-md-12 col-lg-12 col-xl-7">
                      <div className="row">
                        <div className="col-md-7">
                          <div className="datepicker_main_div">
                            <div className="datepicker-container">
                              <DatePicker
                                selected={selectedDate}
                                onChange={handleDateChange}
                                onSelect={handleDateSelect}
                                dayClassName={dayClassName} // Set class for each day based on booking status
                                inline
                                renderDayContents={renderDayContents}
                                dateFormat="yyyy-MM-dd" // Display the date in YYYY-MM-DD format
                              />

                              <div className="legend">
                                {calendarLegend?.map((item, index) => {
                                  return (
                                    <div key={`color-legend-${index}`}>
                                      <span className={`legend-dot ${item.color}`}></span> {item.title}
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5 align_items_center_div">
                          {isLoader ? (
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </Spinner>
                          ) : allScheduledProperties?.scheduledProperties?.length ? (
                            <div
                              className={`${allScheduledProperties?.scheduledProperties?.length ? 'house_details_div mt-0 house_details_scroll w-100' : ''}`}
                            >
                              {allScheduledProperties?.scheduledProperties?.map((schedule, index) => {
                                let CheckTimeOver =
                                  schedule?.booking_status !== 'completed' ? getTimeStamp(new Date()) >= schedule?.booking_date_time : false
                                return (
                                  <div key={index} className="house_details_box">
                                    <div className="house_main_img mb-3">
                                      <img
                                        className="img-fluid"
                                        src={
                                          schedule?.properties?.property_image?.length > 0
                                            ? appendImageURL(schedule?.properties?.property_image[0])
                                            : PropertyCardSliderDefaultImg
                                        }
                                        alt="Image"
                                      />
                                    </div>
                                    <h6 className="fs-16 fw-600 blue_color mb-2">{schedule?.properties?.[0]?.property_name}</h6>
                                    <div className="d-flex gap-3 align-items-center mb-2">
                                      <img className="img-fluid" src={CelanderIcon} alt="Icon" />
                                      <label className="fs-16 fw-400 black_color mb-0">{convertTimestampToDate(schedule?.booking_date_time)}</label>
                                    </div>
                                    <div className="d-flex gap-3 align-items-center mb-2">
                                      <img className="img-fluid" src={ClockIcon} alt="Icon" />
                                      <label className="fs-16 fw-400 black_color mb-0">{convertTimestampToTime(schedule?.booking_date_time)}</label>
                                    </div>
                                    <p className="fs-16 fw-500 blue_color">
                                      <span className="black_color">Status: </span> {capitalizeAndRemoveUnderscore(schedule?.booking_status)}{' '}
                                      {!['completed', 'canceled', 'canceled cleaner']?.includes(schedule?.booking_status) && (
                                        <span className="red_color"> {CheckTimeOver ? OVERDUE : ''}</span>
                                      )}
                                    </p>
                                    <button className="btn btn-primary w-100 mt-3" type="button" onClick={() => handleMoreDetailsClick(schedule)}>
                                      More Details
                                    </button>
                                  </div>
                                )
                              })}
                            </div>
                          ) : (
                            <h4 className="not_found">Data Not Found</h4>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-12 col-xl-5">
                      <div className="house_details_div">
                        <div className="check_in_out_main_div mb-0">
                          <div className="check_in_out_flex_div">
                            <div className="w-100">
                              <p className="black_color fs-16 fw-400 mb-2">Check-Out</p>

                              <div className="common_date_picker_space">
                                <CommonDateTimePicker
                                  name="booking_date_time"
                                  control={scheduleControl}
                                  placeholder="yyyy-MM-ddTHH:mm"
                                  onDateChange={() => {
                                    trigger('booking_date_time')
                                  }}
                                  shouldDisableDate={(date) => isDateBefore(date, new Date())}
                                />
                              </div>
                            </div>
                            <div className="border_div"></div>
                            <div className="w-100">
                              <p className="black_color fs-16 fw-400 mb-2">Next Check-In</p>
                              {/* <p className="gray_color fs-16 fw-400">21/8/2024 04.00 Am</p> */}

                              <div className="common_date_picker_space">
                                <CommonDateTimePicker
                                  name="next_checkin_time"
                                  control={scheduleControl}
                                  placeholder="yyyy-MM-ddTHH:mm"
                                  onDateChange={() => {
                                    trigger('booking_date_time')
                                  }}
                                  shouldDisableDate={(date) => isDateBefore(date, new Date())}
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="coupon_code_div">
                              <div className="input_button_group">
                                <div className="form-group">
                                  <Controller
                                    name="coupon"
                                    control={scheduleControl}
                                    render={({ field: { value, onChange }, fieldState }) => (
                                      <>
                                        <input
                                          className="form-control"
                                          value={value}
                                          type="text"
                                          placeholder="COUPON CODE"
                                          onChange={(e) => onChange(e.target.value)}
                                        />
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          onClick={() => handleApplyCoupon(value)}
                                          disabled={!value || user?.is_freezed_client}
                                        >
                                          Apply
                                        </button>
                                        <small>{fieldState.error?.message}</small>
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="cost_details_div">
                                <p className="fs-16 fw-400 black_color text-nowrap">
                                  Initial Cost : <span className="gray_color">{formatCurrency(initialCost)}</span>
                                </p>
                                <p className="fs-16 fw-400 black_color text-nowrap">
                                  Discount :{' '}
                                  <span className="gray_color">
                                    {discount ? '-' : ''}
                                    {formatCurrency(discount)}
                                  </span>
                                </p>
                                <p className="fs-16 fw-400 black_color text-nowrap">
                                  Final Cost : <span className="gray_color">{formatCurrency(finalCost)}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 col-xl-7 col-md-12 col-12">
                      <button className="btn btn-primary w-100 mt-3" type="button" onClick={handleScheduleCleaningSubmit(onSubmit)}>
                        Schedule Cleaning
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="about">
            <Accordion.Header onClick={() => onAccordionChange('about')}>About</Accordion.Header>
            <Accordion.Body>
              <div className="about_us_tabs_div">
                <div className="d-flex align-content-center gap-5 mb-2">
                  <h5 className="title_small_heading">
                    Room in {getProperty?.property_name}, {getProperty?.city}
                  </h5>
                  <div className="d-flex align-items-center gap-2 edit_btn_div">
                    <img className="img-fluid" src={EditIcon} alt="Icon" />
                    <div
                      className="links_text"
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsAboutToggle(!isAboutToggle)
                      }}
                    >
                      Edit
                    </div>
                  </div>
                </div>
                <div className="hotel_room_info mb-2">
                  <ul>
                    <li>{getProperty?.number_of_rooms} Beds</li>
                    <li>{getProperty?.number_of_bathroom} Bathrooms</li>
                    <li>{getProperty?.square_foot} Square Feet</li>
                  </ul>
                </div>
                <div className="divider_line"></div>
                <div>
                  {!isAboutToggle && (
                    <>
                      <div className="d-flex column-gap-5 row-gap-2 flex-wrap">
                        <div className="d-flex gap-3">
                          <div>
                            <img className="img-fluid" src={RoomIcon} alt="Icon" />
                          </div>
                          <div>
                            <p className="fs-16 fw-400 black_color">Room In A Casa Particular</p>
                            <p className="fs-14 fw-400 gray_color">{getProperty?.number_of_rooms}</p>
                          </div>
                        </div>
                        <div className="d-flex gap-3">
                          <div>
                            <img className="img-fluid" src={BathroomIcon} alt="Icon" />
                          </div>
                          <div>
                            <p className="fs-16 fw-400 black_color">Dedicated Bathroom</p>
                            <p className="fs-14 fw-400 gray_color">{getProperty?.number_of_bathroom} </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {isAboutToggle && (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Number of Rooms<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="number_of_rooms"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="number"
                                  placeholder="Enter Number of Rooms"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('number_of_rooms')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Number of Bathrooms<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="number_of_bathroom"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="number"
                                  placeholder="Enter Number of Bathrooms"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('number_of_bathroom')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>
                            Square Feet<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="square_foot"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="text"
                                  placeholder="Enter Square Feet"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('square_foot')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {/* <div className="mt-3">
                    <Controller
                      name="request_laundry"
                      control={control}
                      checked={true}
                      defaultValue={false}
                      render={({ field }) => (
                        <>
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            label={`I want the cleaner to do the laundry`}
                            {...field}
                            checked={field.value} // ensures checked state is bound to value
                            onChange={() => {
                              handleCheckboxChange(option)
                              trigger('request_laundry')
                            }}
                          />
                          <small>{fieldState?.error?.message}</small>
                        </>
                      )}
                    />
                  </div> */}
                </div>
                {/* <div className="divider_line"></div>  
                <div>
                  <h5 className="title_small_heading mb-2">About This Place</h5>
                  <p className="fs-16 fw-400 gray_color">
                    Get away from routine at this unique and relaxing accommodation, just a few meters from the palapa. Excellent view of the sea from
                    the terrace. The room is available for 4 people, distributed in 2 camera beds, as well as everything you need for a family stay
                    during your holidays in Ciénaga de Zapata.
                  </p>
                </div> */}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      {showMoreDetailModal && (
        <Modal className="scheduledetail_modal_main_div" size="md" centered isOpen={showMoreDetailModal} toggle={toggleMoreDetailModal}>
          <ModalHeader toggle={toggleMoreDetailModal}>
            <ModalTitle className="fw-600">{getProperty?.property_name}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <CleaningScheduleDetail
              scheduleID={scheduleID}
              setIsRefresh={setIsRefresh}
              toggleMoreDetailModal={toggleMoreDetailModal}
              isCanceledBookingStatus={isCanceledBookingStatus}
            />
          </ModalBody>
        </Modal>
      )}
      {/* Accordion Design End */}
    </>
  )
}

export default EditProperty
